"use client";
import { jsx as l } from "react/jsx-runtime";
import { memo as e } from "react";
import r from "../components/Icon/SvgIcon.js";
const t = (o) => /* @__PURE__ */ l(
  r,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 2.4c-5.302 0-9.6 4.298-9.6 9.6s4.298 9.6 9.6 9.6a9.6 9.6 0 0 0 0-19.2M8.928 16.838V6.893l8.64 4.953z",
        clipRule: "evenodd"
      }
    )
  }
), c = e(t);
export {
  c as PlayCircle,
  c as default
};
